import { ErrorMessage } from 'components/ErrorMessage/ErrorMessage';
import { RequestStatusTypes, RouteTypes } from 'consts';
import Header from 'containers/Header';
import { ReactElement, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect, useHistory } from 'react-router-dom';
import {
  RfUiBreadcrumbs,
  RfUiButton,
  RfUiCheckbox,
  RfUiInput,
  RfUiInputFile,
  RfUiModal,
} from 'renfe-components';
import { createStructuredSelector } from 'reselect';
import { makeSelectTokenAccessToken } from 'store/oauth/selectors';
import {
  deleteUserPortraitRquest,
  getUserPortraitRquest,
  postUpdateConsent,
  updateUserPortraitRquest,
} from 'store/usuarios/actions';
import {
  makeSelectGetUserInfoData,
  makeSelectGetUserPhoto,
  makeSelectPerfilesUsuarioDatosPerfilesUsuarioPerfilesParsed,
  makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected,
  makeSelectUpdateUserPortraitRequestStatus,
} from 'store/usuarios/selectors';
import { file2Base64 } from 'utils/files';
import { hasAccess } from 'utils/listUtils';
import { userProfile } from 'utils/profilesIndex';
import './profile.scss';

const links = [
  {
    label: 'Perfil',
    link: '#',
    textHelp: 'Perfil',
    active: true,
  },
];

const selectors: any = createStructuredSelector({
  perfilesUsuarioPerfilesParsed:
    makeSelectPerfilesUsuarioDatosPerfilesUsuarioPerfilesParsed(),
  access_token: makeSelectTokenAccessToken(),
  profileSelected: makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected(),
  userPhoto: makeSelectGetUserPhoto(),
  userInfoData: makeSelectGetUserInfoData(),
  updateUserPortratirRequestStatus: makeSelectUpdateUserPortraitRequestStatus(),
} as any);

const Profile = (): ReactElement => {
  const {
    perfilesUsuarioPerfilesParsed,
    access_token,
    profileSelected,
    userPhoto,
    userInfoData,
    updateUserPortratirRequestStatus,
  } = useSelector<any, any>(selectors);
  const history = useHistory();
  const dispatch = useDispatch();
  const [checkConsent, setcheckConsent] = useState(false);
  const [accept, setAccept] = useState(false);
  const [profileData, setProfileData] = useState({
    nombre: '',
    usuario: '',
    perfil: '',
  });
  const [modalType, setModalType] = useState('');
  const [modalTypeConsent, setModalTypeConsent] = useState('');

  useEffect(() => {
    setcheckConsent(userInfoData.CONSENTIMIENTO === 'S');
  }, [userInfoData]);

  const openPhotoModal = () => {
    setModalType('confirm');
  };

  const openConsentModal = () => {
    setModalTypeConsent('confirm');
  };

  const closePhotoModal = () => {
    setModalType('');
  };

  const closeConsentModal = () => {
    setModalTypeConsent('');

    if (accept === false) {
      setcheckConsent(!checkConsent);
    }

    setAccept(false);
  };

  const confirmModalClose = async () => {
    setcheckConsent(false);
    setAccept(true);
    dispatch(deleteUserPortraitRquest());
  };

  const uploadFile = async (e) => {
    const file: string = await file2Base64(e.detail);
    closePhotoModal();
    dispatch(updateUserPortraitRquest(file));
  };

  const handleCheckConsent = (e) => {
    if (e.detail === false) {
      openConsentModal();
      setcheckConsent(!checkConsent);
      const aux = document.querySelector(
        'rf-ui-input-file input'
      ) as HTMLInputElement;
      if (aux) {
        aux.value = '';
      }
    } else {
      setcheckConsent(!checkConsent);
      dispatch(postUpdateConsent());
    }
  };

  useEffect(() => {
    if (profileSelected) {
      setProfileData({
        nombre: profileSelected.NOMBRE_USUARIO,
        usuario: profileSelected.ID_USUARIO,
        perfil: JSON.parse(perfilesUsuarioPerfilesParsed).find(
          (profile) => profile.ref === profileSelected.ID_PERFIL
        ).label,
      });
    }
  }, [profileSelected]);

  useEffect(() => {
    const updatedPhoto =
      updateUserPortratirRequestStatus.status === RequestStatusTypes.Success;
    const firstLoad =
      updateUserPortratirRequestStatus.status === RequestStatusTypes.Default;

    if (profileSelected && (updatedPhoto || firstLoad)) {
      dispatch(getUserPortraitRquest());
    }
  }, [updateUserPortratirRequestStatus, profileSelected]);

  if (
    !hasAccess(profileSelected, [
      userProfile.alumno.extBecario,
      userProfile.alumno.extAspirante,
      userProfile.alumno.extMaquinista,
    ])
  ) {
    return <Redirect to={RouteTypes.HOME} push />;
  }

  if (!access_token) {
    return <Redirect to={RouteTypes.LOGIN} push />;
  }

  return (
    <>
      <Header />
      <div className="rf-layout rf-practice-list">
        <RfUiBreadcrumbs
          links={JSON.stringify(links)}
          onEventChange={(e: any) => {
            history.push(e.detail);
          }}
        ></RfUiBreadcrumbs>
        <h1 className="rf-title rf-title--simple">Perfil</h1>
        <div>
          {checkConsent && userInfoData.PENDIENTE_DE_VALIDAR === 'TRUE' && (
            <ErrorMessage message="Hay una fotografía pendiente de validar" />
          )}
          <div className="profile-photo">
            <div
              className="profile-photo__img"
              style={{
                backgroundImage: `url('${
                  checkConsent ? userPhoto : './images/user.png'
                }')`,
              }}
            ></div>

            <RfUiButton
              className="profile-photo__button"
              text="qwe"
              type="button"
              aspect="round"
              icon="doc"
              onButtonClick={() => {
                openPhotoModal();
              }}
            >
              {' '}
            </RfUiButton>
          </div>
          <RfUiModal
            title-modal={
              'Si desmarca este check se eliminará cualquier fotografía que exista en el sistema. ¿Desea continuar?'
            }
            id-modal="modalFotoAviso"
            modal-type={modalTypeConsent}
            onModalClose={(e: any) => {
              closeConsentModal();
            }}
            onConfirm={() => {
              confirmModalClose();
            }}
            modalConfirmText="Aceptar"
          ></RfUiModal>

          <RfUiModal
            title-modal={''}
            id-modal="modalFoto"
            modal-type={modalType}
            slotContent={true}
            onModalClose={(e: any) => {
              closePhotoModal();
            }}
            onConfirm={(e: any) => {
              closePhotoModal();
            }}
          >
            <div slot="content" className="profile-upload-photo">
              <div className="profile-upload-photo__container">
                <p className="profile-upload-photo__message">
                  Selecciona una foto <br></br>
                  con las dimensiones indicadas
                </p>

                <RfUiInputFile
                  label-button="Subir foto"
                  value=""
                  aspect="primary"
                  disabled={checkConsent ? false : true}
                  placeholder="Selecciona una foto con las dimensiones indicadas"
                  onFileInputChange={
                    checkConsent ? (e) => uploadFile(e) : () => {}
                  }
                  maxSizeKb={500}
                  acceptedFormats="image/jpeg"
                ></RfUiInputFile>
                {!checkConsent && (
                  <ErrorMessage message="Para poder subir una foto debe marcar el check de consentimiento, en caso contrario, la fotografía no se subirá" />
                )}
              </div>
            </div>
          </RfUiModal>
        </div>

        <h1 className="rf-title rf-title--simple">Alumno</h1>
        <div className="profile-container">
          <div className="rf-box">
            <div className="rf-practice-list__input-container profile-container__name">
              <RfUiInput
                label="Nombre y apellidos"
                value={profileData.nombre}
                disabled={true}
                error={''}
              />
            </div>
            <div className="rf-practice-list__input-container">
              <RfUiInput
                label="Perfil"
                value={profileData.perfil}
                disabled={true}
                error={''}
              />
            </div>
          </div>
          <div className="rf-box">
            <div className="rf-practice-list__input-container">
              <RfUiInput
                label="Usuario"
                value={profileData.usuario}
                disabled={true}
                error={''}
              />
            </div>

            <div className="rf-practice-list__input-container profile-checkbox">
              <RfUiCheckbox
                label="Usuario"
                checked={checkConsent}
                onCheckEvent={handleCheckConsent}
              />
              <p>
                Doy consentimiento para que mi foto pueda ser usada por la
                Gestion de prácticas de conducción y sea visible para los
                instructores, formadores, gestores y administradores de esta
                aplicación con el fin de mejorar la gestión de estas prácticas
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Profile;
